// src/pages/LeadDocs.js
import React, { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import {
  Box,
  Heading,
  Text,
  Stack,
  Badge,
  Divider,
  Button,
  Link,
  Skeleton,
} from '@chakra-ui/react';
import { db } from '../firebaseConfig';
import useOrgSettings from '../hooks/useOrgSettings';

export default function LeadDocs() {
  const { id } = useParams();
  const { orgId } = useOrgSettings();
  const [lead, setLead] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!orgId || !id) return;
    (async () => {
      try {
        const ref = doc(db, `organizations/${orgId}/leads/${id}`);
        const snap = await getDoc(ref);
        setLead(snap.exists() ? { id: snap.id, ...snap.data() } : null);
      } finally {
        setLoading(false);
      }
    })();
  }, [orgId, id]);

  return (
    <Box p={6}>
      <Stack direction="row" justify="space-between" align="center" mb={4}>
        <Heading size="md">Lead Documents</Heading>
        <Button as={RouterLink} to="/leads" variant="outline" size="sm">
          Back to Leads
        </Button>
      </Stack>

      {loading ? (
        <Skeleton height="20" />
      ) : !lead ? (
        <Text>Lead not found.</Text>
      ) : (
        <>
          <Box mb={4}>
            <Text fontWeight="semibold">
              {lead.customerFullName ||
                `${lead.customerFirstName || ''} ${lead.customerLastName || ''}`}{' '}
              <Badge ml={2}>{(lead.status || '').toUpperCase()}</Badge>
            </Text>
            <Text fontSize="sm" color="gray.600">
              {lead.addressLine1}
              {lead.addressLine2 ? `, ${lead.addressLine2}` : ''}, {lead.postcode}
            </Text>
            <Text fontSize="sm" color="gray.600">
              Appointment: {lead.appointment || '—'}
            </Text>
            <Text fontSize="sm" color="gray.600">
              Assigned to: {lead.salespersonName || '—'}
            </Text>
          </Box>

          <Divider mb={4} />

          {/* Placeholder section — storage upload/listing to be wired later */}
          <Box>
            <Heading size="sm" mb={2}>
              Files
            </Heading>
            <Text color="gray.600" mb={3}>
              Coming soon: upload photos/PDFs and view them here.
            </Text>
            <Link as={RouterLink} to={`/leads/${lead.id}/edit`} color="teal.600">
              Go to Lead Details
            </Link>
          </Box>
        </>
      )}
    </Box>
  );
}
